// src/features/wallet/components/WalletBalanceCard.tsx
import { Card, formatPersianNumber } from '../../../app/components/foundation';
import type { Wallet } from '../types/wallet.types';

export interface WalletBalanceCardProps {
  wallet: Wallet;
}

/**
 * Workspace card: current balance, currency, and available balance.
 * Pulls straight off the base Wallet record — same self-contained
 * approach as WalletInfoCard, no additional mock data needed for this
 * one. Same field-list markup as
 * commission/components/CommissionInfoCard.tsx.
 */
export function WalletBalanceCard({ wallet }: WalletBalanceCardProps) {
  return (
    <Card className="vania-wallet-workspace-card">
      <h2 className="vania-wallet-workspace-card-title">موجودی</h2>

      <dl className="vania-wallet-workspace-fieldlist">
        <div>
          <dt>موجودی فعلی</dt>
          <dd dir="ltr">{formatPersianNumber(wallet.balance)}</dd>
        </div>
        <div>
          <dt>واحد پول</dt>
          <dd>تومان</dd>
        </div>
        <div>
          <dt>موجودی قابل برداشت</dt>
          <dd dir="ltr">{formatPersianNumber(wallet.balance)}</dd>
        </div>
      </dl>
    </Card>
  );
}
